/* ==========================================================================
   Cart: AJAX add / update / remove against Shopify's native Cart API.
   Uses the Section Rendering API to re-render the drawer HTML after
   every mutation, and event delegation so re-rendered DOM stays wired up.
   ========================================================================== */
(function () {
  'use strict';

  var CART_DRAWER_SECTION = 'cart-drawer-section';

  function getCartDrawerEl() {
    return document.getElementById('CartDrawer');
  }

  function openDrawer() {
    var drawer = getCartDrawerEl();
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    theme.lockScroll();
    theme.lockFocusTrap(drawer.querySelector('.cart-drawer__panel'));
  }

  function closeDrawer() {
    var drawer = getCartDrawerEl();
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    theme.unlockScroll();
    theme.releaseFocusTrap();
    var toggle = document.querySelector('[data-cart-drawer-open]');
    if (toggle) toggle.focus();
  }

  function updateCartCountBubbles(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
  }

  function refreshDrawerMarkup() {
    return fetch('/?sections=' + CART_DRAWER_SECTION)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data[CART_DRAWER_SECTION];
        if (!html) return;
        var wasOpen = getCartDrawerEl() && getCartDrawerEl().getAttribute('aria-hidden') === 'false';
        var temp = document.createElement('div');
        temp.innerHTML = html.trim();
        var newDrawer = temp.querySelector('#CartDrawer');
        var oldDrawer = getCartDrawerEl();
        if (newDrawer && oldDrawer) {
          if (wasOpen) newDrawer.setAttribute('aria-hidden', 'false');
          oldDrawer.replaceWith(newDrawer);
        }
      });
  }

  function refreshCartPage() {
    var cartResults = document.querySelector('[data-cart-items]');
    if (!cartResults || !document.body.classList.contains('template-cart')) return Promise.resolve();
    return fetch(window.location.pathname).then(function (res) { return res.text(); }).then(function (html) {
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var newSection = temp.querySelector('.cart-page');
      var oldSection = document.querySelector('.cart-page');
      if (newSection && oldSection) oldSection.replaceWith(newSection);
    });
  }

  function handleCartResponse(cart) {
    updateCartCountBubbles(cart.item_count);
    return Promise.all([refreshDrawerMarkup(), refreshCartPage()]);
  }

  /* ---- Add to cart ---- */
  function handleAddToCartSubmit(form) {
    var formData = new FormData(form);
    var button = form.querySelector('[data-add-to-cart], button[type="submit"]');
    if (button) {
      button.classList.add('is-loading');
      button.disabled = true;
    }

    var body = {};
    formData.forEach(function (value, key) {
      if (key === 'id') body.id = value;
      else if (key === 'quantity') body.quantity = Number(value) || 1;
    });
    if (!body.quantity) body.quantity = 1;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        return handleCartResponse(cart);
      })
      .then(function () {
        if (settingsCartType() === 'drawer') openDrawer();
        else if (settingsCartType() === 'page') window.location.href = document.body.getAttribute('data-cart-url') || '/cart';
        var textEl = button && button.querySelector('[data-add-to-cart-text]');
        if (textEl) {
          var original = textEl.textContent;
          textEl.textContent = 'Added';
          setTimeout(function () { textEl.textContent = original; }, 1800);
        }
      })
      .catch(function (err) {
        console.error(err);
        var message = (err && err.description) || 'This item could not be added to your bag.';
        alert(message);
      })
      .finally(function () {
        if (button) {
          button.classList.remove('is-loading');
          button.disabled = false;
        }
      });
  }

  function settingsCartType() {
    return document.body.getAttribute('data-cart-type') || 'drawer';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-quick-add-form], #ProductForm');
    if (!form) return;
    event.preventDefault();
    handleAddToCartSubmit(form);
  });

  /* ---- Quantity change / remove (delegated) ---- */
  var pendingChange = null;

  function changeLineQuantity(line, quantity) {
    if (pendingChange) clearTimeout(pendingChange);
    pendingChange = setTimeout(function () {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(handleCartResponse)
        .catch(function (err) { console.error(err); });
    }, 300);
  }

  document.addEventListener('click', function (event) {
    var decreaseBtn = event.target.closest('[data-quantity-decrease]');
    var increaseBtn = event.target.closest('[data-quantity-increase]');
    var removeBtn = event.target.closest('[data-cart-remove]');

    if (decreaseBtn || increaseBtn) {
      var wrapper = (decreaseBtn || increaseBtn).closest('[data-quantity-input]');
      var input = wrapper.querySelector('[data-quantity-field]');
      var value = parseInt(input.value, 10) || 1;
      value = decreaseBtn ? Math.max(0, value - 1) : value + 1;
      input.value = value;
      var line = wrapper.getAttribute('data-line');
      if (line) changeLineQuantity(line, value);
    }

    if (removeBtn) {
      var line2 = removeBtn.getAttribute('data-line');
      if (line2) changeLineQuantity(line2, 0);
    }

    if (event.target.closest('[data-cart-drawer-open]')) {
      event.preventDefault();
      openDrawer();
    } else if (event.target.closest('[data-cart-drawer-close]')) {
      closeDrawer();
    }
  });

  document.addEventListener('change', function (event) {
    var field = event.target.closest('[data-quantity-field]');
    if (!field) return;
    var wrapper = field.closest('[data-quantity-input]');
    var line = wrapper && wrapper.getAttribute('data-line');
    var value = parseInt(field.value, 10);
    if (isNaN(value) || value < 0) value = 0;
    field.value = value;
    if (line) changeLineQuantity(line, value);
  });

  document.addEventListener('theme:escape', function () {
    var drawer = getCartDrawerEl();
    if (drawer && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
  });

  /* ---- Cart note ---- */
  var noteField = document.querySelector('[data-cart-note]');
  if (noteField) {
    noteField.addEventListener(
      'change',
      theme.debounce(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: noteField.value })
        });
      }, 400)
    );
  }
})();
